import { defineStore } from "pinia"

export const useStudentGroupsStore = defineStore("studentGroupsStore", {
  state: () => ({
    modalOpen: false,
  }),

  actions: {
    setModalOpen(isOpen: boolean) {
      this.modalOpen = isOpen
    },
  },
})
